import React from 'react';
import { View, StyleSheet } from 'react-native';
import Config from '../../libraries/ReactNativeConfig';
import AddToCart from './AddToCart';
import PRODUCT from '../../config/LayoutConstants/ProductConfig';
import AppConfig from '../../config/AppConfig';
import { ProductDetailStyles } from './styles';
import RequestProductButton from './RequestProductButton';
import Utility from '../../utils/Utility';
import { SCREEN_CONSTANTS } from '../../config/ScreenConstants';
import { getStockedStatus, isInStock, isVariantInStockShopifyDirect } from '../../utils/ProductUtility';

const StockStatus = {
  IN_STOCK: 'in_stock',
  OUT_OF_STOCK: 'out_of_stock',
};

const ProductPricingAndAddToCart = (props) => {
  const {
    currentSku,
    selectedVariant,
    itemData,
    avoidPositionAbsolute,
    showToast,
    isDesktopProductPage = false,
    fromProductPage = false,
    shopifyDirect = false,
  } = props;
  const { IN_STOCK, OUT_OF_STOCK } = StockStatus;
  let isOOS = false;
  let stockedStatus = IN_STOCK;
  if (!shopifyDirect) {
    stockedStatus = Utility.isPresent(selectedVariant)
      ? getStockedStatus(selectedVariant.stocked_status, selectedVariant.web_stocked_status)
      : getStockedStatus(itemData.stocked_status, itemData.web_stocked_status);
    isOOS = !isInStock(stockedStatus);
  } else {
    isOOS = !isVariantInStockShopifyDirect(selectedVariant);
    stockedStatus = isOOS ? OUT_OF_STOCK : IN_STOCK;
  }
  let containerStyle = isDesktopProductPage
    ? ProductDetailStyles.PricingContainerDesktop
    : ProductDetailStyles.pricingAndCartContainer;
  if (AppConfig.getBooleanValue(Config.REMOVE_PRODUCT_REQUEST_BUTTON)) {
    containerStyle = ProductDetailStyles.OosPricingAndCartContainer;
  }

  if (isOOS) {
    return (
      <View style={containerStyle}>
        <RequestProductButton
          skuId={currentSku}
          stocked_status={stockedStatus}
          showToast={showToast}
          extraButtonStyles={isDesktopProductPage && styles.RequestProductButton}
        />
      </View>
    );
  }

  let pricingContainer = avoidPositionAbsolute
    ? ProductDetailStyles.pricingAndCartContainerWithoutAbsolute
    : ProductDetailStyles.pricingAndCartContainer;

  if (isDesktopProductPage) {
    pricingContainer = ProductDetailStyles.PricingContainerDesktop;
  }

  return (
    <View style={pricingContainer}>
      <AddToCart
        addToCartLayout={PRODUCT.ADD_TO_CART_LAYOUT.PRODUCT_DETAIL}
        skuId={currentSku}
        hasVariants={itemData.has_variants}
        selectedVariant={selectedVariant}
        itemData={itemData}
        alwaysShowQuantitySelector={AppConfig.getBooleanValue(
          Config.SHOW_QUANTITY_IN_ADD_TO_BAG_ALWAYS,
        )}
        buyNowButtonStyle={isDesktopProductPage && styles.addToCartButton}
        fromProductPage={fromProductPage}
        previousScreen={SCREEN_CONSTANTS.PRODUCT_DETAIL}
        shopifyDirect={shopifyDirect}
      />
      <AddToCart
        addToCartLayout={PRODUCT.ADD_TO_CART_LAYOUT.PRODUCT_DETAIL}
        skuId={currentSku}
        hasVariants={itemData.has_variants}
        selectedVariant={selectedVariant}
        itemData={itemData}
        isBuyNow={!AppConfig.getBooleanValue(Config.HIDE_BUY_NOW)}
        buyNowButtonStyle={isDesktopProductPage && styles.addToCartButton}
        fromProductPage={fromProductPage}
        previousScreen={SCREEN_CONSTANTS.PRODUCT_DETAIL}
        stockedStatus={stockedStatus}
        shopifyDirect={shopifyDirect}
      />
    </View>
  );
};

export default React.memo(ProductPricingAndAddToCart);

const styles = StyleSheet.create({
  addToCartButton: {
    width: 220,
  },
  RequestProductButton: {
    width: 460,
  },
});
